<template>
  <div :class="$style.search">
    <label>
      <input
        v-model="filter"
        :class="$style.input"
        type="text"
        :placeholder="resolvedPlaceholder"
      >
    </label>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        default: 'filter',
      },
      placeholder: {
        type: String,
        default: '',
      },
    },
    computed: {
      resolvedPlaceholder() {
        return this.placeholder || this.$t('pages.wordFilter');
      },
      filter: {
        get() {
          return this.$route.query[this.name];
        },
        set(val) {
          if (val === this.$route.query[this.name]) {
            return;
          }
          if (val) {
            this.$router.replace({
              query: { ...this.$route.query, [this.name]: val },
            });
          } else {
            const query = { ...this.$route.query };
            delete query[this.name];
            this.$router.replace({ query });
          }
        },
      },
    },
  };
</script>

<style lang="scss" module>
  .search {
    margin: 0 5px;
  }
  .input {
    border: 1px solid $borderColor;
    color: $black;
    font-size: 14px;
    line-height: 20px;
    padding: 6px 12px;

    &::placeholder {
      color: dakren($dark-gray, 3%);
    }
  }
</style>
